import getAxiosInstance from "../../getAxiosInstance";

export default async function signinWithEmail({
  emailAddress,
  workspaceEid,
  destinationPath,
}: {
  emailAddress: string;
  workspaceEid?: string;
  destinationPath?: string;
}) {
  try {
    const res = await getAxiosInstance().put("/credentials/email", {
      emailAddress,
      workspaceEid,
      destinationPath,
    });
    return {
      ok: res.status === 204,
      ...res,
    };
  } catch (err) {
    return {
      ok: false,
      ...err.response,
    };
  }
}
